"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
/**
 * @license
 * Copyright 2016 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { WatchableValue } from "#src/trackable_value.js";
import {
  registerRPC,
  registerSharedObject,
  SharedObjectCounterpart
} from "#src/worker_rpc.js";
const CHANGED_RPC_METHOD_ID = "SharedWatchableValue.changed";
export let SharedWatchableValue = class extends SharedObjectCounterpart {
  base;
  /**
   * The value is being updated to reflect a remote change.
   * @internal
   */
  updatingValue_ = false;
  constructor(rpc, options = {}) {
    super(rpc, options);
    if (rpc !== void 0) {
      this.base = new WatchableValue(options.value);
      this.setupChangedHandler();
    }
  }
  initializeCounterpart(rpc, options = {}) {
    options.value = this.value;
    super.initializeCounterpart(rpc, options);
  }
  setupChangedHandler() {
    this.registerDisposer(
      this.base.changed.add(() => {
        if (this.updatingValue_) {
          this.updatingValue_ = false;
        } else {
          const { rpc } = this;
          if (rpc !== null) {
            rpc.invoke(CHANGED_RPC_METHOD_ID, {
              id: this.rpcId,
              value: this.value
            });
          }
        }
      })
    );
  }
  static makeFromExisting(rpc, base) {
    const obj = new SharedWatchableValue();
    obj.base = base;
    obj.setupChangedHandler();
    obj.initializeCounterpart(rpc);
    return obj;
  }
  static make(rpc, value) {
    return SharedWatchableValue.makeFromExisting(
      rpc,
      new WatchableValue(value)
    );
  }
  get value() {
    return this.base.value;
  }
  set value(value) {
    this.base.value = value;
  }
  get changed() {
    return this.base.changed;
  }
};
SharedWatchableValue = __decorateClass([
  registerSharedObject("SharedWatchableValue")
], SharedWatchableValue);
registerRPC(CHANGED_RPC_METHOD_ID, function(x) {
  const obj = this.get(x.id);
  obj.updatingValue_ = true;
  obj.base.value = x.value;
  obj.updatingValue_ = false;
});
